/** A obrigação pertence ao formato, não a todos os produtos do Totem. */
export function moldurasEventoValidas(molduras, tipo, agora = Date.now()) {
  return molduras.filter((moldura) => {
    const dados = moldura?.dados;
    if (
      !dados?.evento ||
      dados.tipo !== tipo ||
      !/^https:\/\//.test(dados.url || "")
    ) {
      return false;
    }
    if (!dados.expiraEm) return true;
    const vencimento = Date.parse(dados.expiraEm);
    return Number.isFinite(vencimento) && vencimento > agora;
  });
}

export function moldurasVisiveis(
  molduras,
  tipo,
  orientacao,
  agora = Date.now()
) {
  const exclusivas = moldurasEventoValidas(molduras, tipo, agora);
  const candidatas = exclusivas.length
    ? exclusivas
    : molduras.filter((moldura) => !moldura?.dados?.evento);
  return candidatas.filter(
    (moldura) =>
      moldura?.dados?.tipo === tipo && moldura.dados.orientacao === orientacao
  ).sort((a, b) => {
    const destaqueA = a.dados.destaque === true;
    const destaqueB = b.dados.destaque === true;
    if (destaqueA !== destaqueB) return destaqueA ? -1 : 1;
    if (!destaqueA) return 0;
    const ordemA = Number(a.dados.ordemDestaque);
    const ordemB = Number(b.dados.ordemDestaque);
    const rankA = Number.isSafeInteger(ordemA) && ordemA > 0 ? ordemA : Number.MAX_SAFE_INTEGER;
    const rankB = Number.isSafeInteger(ordemB) && ordemB > 0 ? ordemB : Number.MAX_SAFE_INTEGER;
    return rankA - rankB;
  });
}
